import type { TranslationKey } from '@/lib/i18n';

export const COUNTRY_SELECTOR_POPUP_TITLE = [
  'common:countrySelectorPopup.title',
  'Choose your shipping country',
] as const satisfies TranslationKey;

export const COUNTRY_SELECTOR_POPUP_SUBTITLE = [
  'common:countrySelectorPopup.subtitle',
  'Prices and delivery options vary by location.',
] as const satisfies TranslationKey;
